import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import CollapsibleContainer, { Trigger } from '../CollapsibleContainer';
import {
  doRemoveContact,
  doUpdateCloseContact,
  doUpdateContact,
  resetError,
} from '../../../../data/user/contact/actions';
import { useDispatch, useSelector } from 'react-redux';
import ContactFormContainer, { formType } from './ContactFormContainer';
import { userSelector } from '../../../../data/selector';

// errors shown here: error if setting close contact failed
const ContactList = ({ contactFeatureOn }) => {
  let [showContent, toggleShowContent] = useState(true);
  let [form, setForm] = useState({ name: formType.LIST });

  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const contacts = user.contacts;

  useEffect(() => {
    dispatch(resetError());
  }, [dispatch]);

  const dispatchableActions = {
    updateContact: (formData) => dispatch(doUpdateContact(formData)),
    setCloseContact: (id) => dispatch(doUpdateCloseContact(id)),
    removeContact: (id) => dispatch(doRemoveContact(id)),
    resetError: () => dispatch(resetError()),
  };

  const _setForm = (form) => {
    setForm(form);
    dispatch(resetError());
  };

  let containerClassNames = classnames('ot-relatives', {
    'ot-relatives--loading': contacts.isFetching,
  });
  return (
    <CollapsibleContainer
      className={containerClassNames}
      showContent={showContent}
      toggleShowContent={() => toggleShowContent(!showContent)}
      content={
        <ContactFormContainer
          actions={dispatchableActions}
          setForm={_setForm}
          form={form}
          contacts={contacts}
          contactFeatureOn={contactFeatureOn}
        />
      }
      trigger={<Trigger icon={'icon-user'} name={'Yhteyshenkilöt'} />}
      controls={null}
    />
  );
};

export default ContactList;
